// extracted by mini-css-extract-plugin
export default {"drawerContainer":"GlobalChatPopup_drawerContainer__s6EzV"};